import { PhxTableCellStringInput, PhxTableCellStringSegment } from '../phx-table.types';
import { DEFAULT_SECONDARY_AND_TERTIARY_CONFIG } from './phx-table-cell.const';

/**
 * Normalizes a `phxSecondary`/`phxTertiary`-shaped input (`string | string[] | segment | segment[]`)
 * into a segment array. Shared by phx-table-cell-string and phx-table-cell-tag so both render
 * multi-part, bullet-separated sub-lines identically.
 */
export function normalizeCellStringInput(input: PhxTableCellStringInput): PhxTableCellStringSegment[] {
  if (typeof input === 'string') {
    return [{ value: input, ...DEFAULT_SECONDARY_AND_TERTIARY_CONFIG }];
  }
  if (Array.isArray(input)) {
    const result: PhxTableCellStringSegment[] = [];
    for (const item of input) {
      if (!item) continue;
      if (typeof item !== 'string' && !item.value) continue;
      result.push(
        typeof item === 'string'
          ? { value: item, ...DEFAULT_SECONDARY_AND_TERTIARY_CONFIG }
          : { ...DEFAULT_SECONDARY_AND_TERTIARY_CONFIG, ...item },
      );
    }
    return result;
  }
  return [{ ...DEFAULT_SECONDARY_AND_TERTIARY_CONFIG, ...input }];
}

/**
 * trackBy for secondary/tertiary segment arrays. Required — without it, `*ngFor` diffs by
 * object identity, and a freshly-allocated array (e.g. from a non-memoized getter) tears down
 * and rebuilds each item's tooltip/DOM every change-detection pass. See the phx-table skill,
 * "Reference stability", for the incident this fixes.
 */
export function trackBySegmentValue(index: number, segment: PhxTableCellStringSegment): string {
  return segment.value;
}
